import { useState, useEffect } from "react";
import axios from "axios";
import { Separator } from "@/components/ui/separator";
import { getApiUrl } from "@/lib/api";

const API = getApiUrl();

export default function BreakfastMenuSection() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/breakfast-menu`)
      .then((res) => setItems(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const categories = [...new Set(items.map((i) => i.category))];

  return (
    <section id="breakfast-menu" data-testid="breakfast-menu-section" className="py-20 md:py-32 bg-[#051F16]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 reveal reveal-up">
          <p className="text-xs uppercase tracking-[0.3em] text-[#EAB308] mb-4">
            Ranní nabídka
          </p>
          <h2 className="font-['Playfair_Display'] text-3xl md:text-5xl font-semibold text-[#F0FDF4] tracking-tight">
            Snídaně
          </h2>
        </div>

        {loading ? (
          <div className="flex justify-center py-12">
            <div className="w-8 h-8 border-2 border-[#EAB308] border-t-transparent rounded-full animate-spin" />
          </div>
        ) : items.length === 0 ? (
          <p className="text-center text-[#94A3B8]">Menu snídaní bude brzy doplněno</p>
        ) : (
          <div className="space-y-12 reveal reveal-up stagger-children">
            {categories.map((cat) => (
              <div key={cat} data-testid={`breakfast-category-${cat}`}>
                <h3 className="font-['Playfair_Display'] text-xl md:text-2xl text-[#EAB308] mb-6 tracking-tight">
                  {cat}
                </h3>
                <div className="space-y-4">
                  {items.filter((i) => i.category === cat).map((item) => (
                    <div key={item.id}>
                      <div className="flex items-baseline menu-item-row" data-testid={`breakfast-item-${item.id}`}>
                        <span className="text-[#F0FDF4] font-medium text-base">{item.name}</span>
                        <span className="menu-dots" />
                        <span className="text-[#EAB308] font-bold text-base whitespace-nowrap">{item.price}</span>
                      </div>
                      {item.description && (
                        <p className="text-sm text-[#94A3B8] mt-1 ml-0">{item.description}</p>
                      )}
                      {item.allergens && (
                        <p className="text-xs text-[#94A3B8]/60 mt-0.5">Alergeny: {item.allergens}</p>
                      )}
                    </div>
                  ))}
                </div>
                <Separator className="mt-8 bg-[#1D4133]/50" />
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
